//
//
//
//
//
//
//

export default {
  name: 'ui-checker',
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: [String, Number, Boolean],
      require: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      value: this.model
    }
  },
  methods: {
    updateVal () {
      this.$nextTick(() => {
        this.$emit('change', this.value)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/uiChecker.vue